/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ThreadId } from "../../commons/types/ThreadId";
import { ThreadMetadata } from "./ThreadMetadata";
import { ThreadState } from "./ThreadState";
import { ThreadStatus } from "./ThreadStatus";
export const ThreadModel = core.serialization.object({
    id: ThreadId,
    resourceId: core.serialization.string(),
    metadata: ThreadMetadata.optional(),
    source: core.serialization.string().optional(),
    state: ThreadState.optional(),
    status: ThreadStatus,
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
});
